import { styled } from 'Theme'

export const StyledListExtraRight = styled.div`
  flex: 0 1 auto;
  padding: ${({ theme }): string => theme.list.item.right.padding};
`
